export const getDefaultAlignment = (formatting: unknown) => {
  return formatting === 'number' ? 'right' : 'left';
};
